import type { GameCardData } from "./game-card";

export const marbleXGames: GameCardData[] = [
  {
    id: "villains",
    name: "Villains",
    subtitle: "Awaken your ultimate Villain\nJoin $5K Leaderboard",
    description: "Jump into chaotic 4-minute battles and unleash true power",
    icon: "/images/marblex-games/tile-logo-villains.webp",
    backgroundImage: "/images/marblex-games/tile-bg-villains.webp",
    url: "https://play.immutable.com/games/villains/",
    slug: "villains",
  },
  {
    id: "mtdz",
    name: "Meta Toy: DragonZ SAGA",
    subtitle: "Leaderboard racing for\n$4K rewards",
    description: "Collect and power up 300+ Dragons to climb higher",
    icon: "/images/marblex-games/tile-logo-mtdz.webp",
    backgroundImage: "/images/marblex-games/tile-bg-mtdz.webp",
    url: "https://play.immutable.com/games/mtdz/",
    slug: "mtdz",
  },
  {
    id: "dice-go",
    name: "Dice Go",
    subtitle: "500 Gems - Test your\nfortune and strategy",
    description: "Fast-paced dice battles with strategy, speed, and big wins",
    icon: "/images/marblex-games/tile-logo-dicego.webp",
    backgroundImage: "/images/marblex-games/tile-bg-dicego.webp",
    url: "https://play.immutable.com/games/dice-go/",
    slug: "dice-go",
  },
  {
    id: "self-made-billionaire",
    name: "Selfmade Billionaire",
    subtitle: "Start playing and build your empire",
    description:
      "Buy dips, ride waves, and outsmart rivals to reach billionaire status",
    icon: "/images/marblex-games/tile-logo-selfmade.webp",
    backgroundImage: "/images/marblex-games/tile-bg-selfmade.webp",
    url: "https://play.immutable.com/games/self-made-billionaire/",
    slug: "self-made-billionaire",
  },
];
